<template>
  <SettingsPageFull>
    <template #title>
      <div class="flex space-x-3">
        <font-awesome-icon :icon="['fal', 'ticket']" size="2x" />
        <span class="text-2xl font-bold capitalize-first">
          {{ $t('navigation.content_item_title') }}
        </span>
      </div>
    </template>

    <template #cta>
      <div class="flex gap-x-3">
        <BaseButton
          v-if="$can('manage_content')"
          color="primary"
          icon="plus"
          @click="this.$router.push({ name: 'settings_create_item_route' })"
          :title="$t('button.add_new_m', { var: $t('global.item') })"
        />
        <BaseButton
          icon="arrow-square-down"
          :title="$t('global.export_items')"
          @click="submitExportForm"
        />
      </div>
    </template>

    <template #body>
      <BaseContentTable
        v-if="metadata.columns || loading"
        :columns="metadata.columns ?? []"
        :loading="loading"
        :modelList="itemsList"
        :search="true"
        @rowClick="redirectToModelPage"
        @refreshClick="withLoading(fetchAllItem())"
        @deleteModel="deleteItem"
        :isHoverable="true"
      />
    </template>
  </SettingsPageFull>
</template>

<script>
import loadingMixin from '@u/mixins/loading.mixin'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TheItemIndexPage',
  mixins: [loadingMixin],
  computed: {
    ...mapGetters({
      itemsList: 'item/getItemList',
      metadata: 'item/getItemMetadata'
    })
  },
  methods: {
    ...mapActions({
      fetchAllItem: 'item/fetchAllItem',
      deleteItemById: 'item/deleteItemById',
      undoDeleteItemById: 'item/undoDeleteItemById',
      processFetchItemsExportAction: 'item/fetchItemsExport'
    }),
    redirectToModelPage(id) {
      this.$router.push({
        name: 'settings_edit_item_route',
        params: { id: id }
      })
    },
    deleteItem(id) {
      this.deleteItemById({
        id: id
      }).then(() => {
        this.$h.toastAction(
          'delete',
          this.$t('toasts.deleted_m', { var: this.$t('attributes.item') }),
          null,
          [
            {
              title: this.$t('button.cancel'),
              class: 'text-red-700',
              action: () => this.undoDeleteItem(id)
            }
          ]
        )
      })
    },
    undoDeleteItem(id) {
      this.undoDeleteItemById({
        id: id
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.reseted_m', { var: this.$t('attributes.item') })
        )
      })
    },
    submitExportForm() {
      console.log('export')
      this.processFetchItemsExportAction()
    }
  },
  beforeMount() {
    this.withLoading(this.fetchAllItem())
  }
}
</script>
